module.exports = __webpack_public_path__ + "img/中国电子节能协会LOGO.61ee0d61.png";